/** @jsxImportSource @emotion/react */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomDialog from 'components/modals/common/CustomDialog';
import CustomGrid from '../../../components/grids/CustomGrid';
import { findMpEquipment, findMpEquipmentHistory } from '../../../apis/mp/MpEquipment';
import { MpEquipment, MpEquipmentHistory } from '../../../models/mp/MpEquipment';
import { useMessageBar } from '../../../hooks/useMessageBar';
import { tb } from '../../../components/layouts/Table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { MpItem } from '../../../models/mp/MpItem';
import { SubTitleGroup, SubTitleLayout } from '../../../components/layouts/ContentLayout';
import { Button } from '@mui/material';
import { IconButton } from '../../../components/buttons/IconSVG';
import CustomInputWithSearch from '../../../components/inputs/CustomInputWithSearch';
import { ComboBox } from '../../../components/selects/ComboBox';
import { Code } from '../../../models/common/CommonCode';
import { getCommonCodeNames } from '../../../apis/admin/CommonCode';
import { CommonUtil } from '../../../utils/CommonUtil';
import { GridStatusCellTemplate } from '../../../components/grids/GridStatusCellRenderer';
import useEvent from 'react-use-event-hook';
import { CrudCode } from '../../../models/common/Edit';
import * as input from '@grapecity/wijmo.input';

interface Props {
  open: boolean;
  close: (isDone?: boolean) => void;
  title: string;
  initParam: {
    mpSftyClsf?: string;
    mpItemId?: string;
  };
  onCallbackData: any; //ddd
}

export interface mpRemarkData {
  mpItemId?: string;
  mpSftyClsf?: string;
  mpSftyClsfNM?: string;
  checked?: boolean;
}

export const MpSftyClsfPopUp = ({ open, close, title, initParam, onCallbackData }: Props) => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();

  const [mpRemarkData, setMpRemarkData] = useState<mpRemarkData[]>([]);
  const [checkedItems, setCheckedItems] = useState<mpRemarkData[]>([]);

  const gridRef = useRef<any>();

  const [codeMpSftyClsf, setCodeMpSftyClsf] = useState<any>({});

  //init
  useEffect(() => {
    getCommonCodes();
  }, [initParam]);

  useEffect(() => {
    console.log(mpRemarkData);
  }, [mpRemarkData]);

  const getCommonCodes = async () => {
    const mpSftyClsf: Code[] = await getCommonCodeNames('MP_SFTY_CLSF');
    setCodeMpSftyClsf(mpSftyClsf);

    const list = initParam.mpSftyClsf;

    const d = mpSftyClsf.reduce(
      (acc, cur) => [
        ...acc,
        {
          mpSftyClsf: cur.cmnCd,
          mpSftyClsfNm: cur.cmnCdNm,
          mpItemId: initParam.mpItemId,
          checked: list?.includes(cur.cmnCd || ''),
        },
      ],
      [] as any
    );
    setMpRemarkData(d);
  };

  const handleConfirm = () => {
    onCallbackData(mpRemarkData);
    close();
  };

  const handleClose = () => {
    setMpRemarkData([]); // dddfsklj;fkdj d //
    close();
  };

  const dialogButtons = [
    <Button
      key={'confirm'}
      css={IconButton.button}
      className="confirm"
      onClick={handleConfirm}
      disableRipple
    >
      {t('com.button.저장', '저장')}
    </Button>,
  ];

  const onInitialized = useEvent((grid) => {
    gridRef.current = grid;

    grid.loadedRows.addHandler(() => {
      grid.rows.forEach((row) => {
        const multiSelect = grid.columns.find((col) => col.binding === 'mpSftyClsf');

        if (multiSelect && row.dataItem.getChecks) {
          multiSelect.checkedItems = codeMpSftyClsf.filter((o) =>
            row.dataItem.getChecks.includes(o.cmnCd)
          );
        }
      });
    });

    grid.hostElement.addEventListener('click', (e) => {
      if (grid.rows.length == 0) return;

      const ht = grid.hitTest(e);

      if (ht.row < 0 || ht.col < 0) return;

      if (ht.panel === grid.cells) {
        const item = grid.rows[ht.row].dataItem;
        const binding = grid.columns[ht.col].binding;

        // 부서 클릭
        if ('mpSftyClsf' === binding && item.crudKey === CrudCode.CREATE) {
          item.showFilterInput = e.target.checked;
        }
      }
    });
  });

  const onCheckedItemsChanged = useEvent((sender) => {
    setCheckedItems(sender.checkedItems);
  });

  // const layoutDefinition = [
  const layoutDefinition = useMemo(() => {
    return [
      {
        binding: 'crudKey',
        header: String(t('com.label.상태', '상태')),
        width: 50,
        align: 'center',
        cellTemplate: GridStatusCellTemplate,
        visible: false,
      },
      {
        binding: 'checked',
        header: String(t('com.label.선택', '선택')),
        width: 50,
        align: 'center',
      },
      {
        binding: 'mpSftyClsf',
        header: String(t('com.label.remark', 'remark')),
        align: 'left',
        width: 120,
        editor: new input.MultiSelect(document.createElement('div'), {
          placeholder: '선택',
          showSelectAllCheckbox: true,
          maxHeaderItems: 5,
          // headerFormat: '{count:n0} items', //Cell에 비해 데이터 내용이 많을 경우....원하는 형태 처리.
          itemsSource: codeMpSftyClsf, //배열
          displayMemberPath: 'cmnCdNm', //목록에 표시되는  항목의 속성
          selectedValuePath: 'cmnCd',
          checkedItemsChanged: (sender) => {
            return sender.checkedItems.map((checkableItem) => checkableItem.cmnCd);
          },
        }),
      },
      {
        binding: 'mpSftyClsfNm',
        header: String(t('com.label.remark', 'remark')),
        align: 'left',
        isReadOnly: true,
        width: '*',
      },
    ];
  }, [mpRemarkData]);

  return (
    <>
      <CustomDialog
        title={title}
        open={open}
        onClose={handleClose}
        onCancel={handleClose}
        size="xs"
        buttons={dialogButtons}
      >
        <CustomGrid
          layoutDefinition={layoutDefinition}
          rowData={mpRemarkData}
          initialized={onInitialized}
          height={350}
          allowPinning={false}
          showCheckAll={true}
          // loadedRows={(grid, e) => {
          //   grid.rows.forEach((row) => {
          //     row.isSelected = row.dataItem.checked;
          //   });
          // }}
          selectionChanged={onCheckedItemsChanged}
        />
      </CustomDialog>
    </>
  );
};
